export default function NetworkLines({ className = "" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 1200 600"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="bek-line-gradient" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#C7CDD6" stopOpacity="0" />
          <stop offset="50%" stopColor="#C7CDD6" stopOpacity="0.8" />
          <stop offset="100%" stopColor="#C7CDD6" stopOpacity="0" />
        </linearGradient>
      </defs>
      {/* Horizontal lines */}
      <line className="bek-network-line" x1="0" y1="120" x2="1200" y2="120" stroke="url(#bek-line-gradient)" />
      <line className="bek-network-line" x1="0" y1="240" x2="1200" y2="240" stroke="url(#bek-line-gradient)" style={{ animationDelay: "0.8s" }} />
      <line className="bek-network-line" x1="0" y1="380" x2="1200" y2="380" stroke="url(#bek-line-gradient)" style={{ animationDelay: "1.6s" }} />
      <line className="bek-network-line" x1="0" y1="500" x2="1200" y2="500" stroke="url(#bek-line-gradient)" style={{ animationDelay: "2.4s" }} />

      {/* Diagonal lines */}
      <path className="bek-network-line" d="M 0 0 L 1200 600" />
      <path className="bek-network-line" d="M 1200 0 L 0 600" style={{ animationDelay: "1.2s" }} />

      {/* Nodes */}
      {[
        [120, 120], [380, 240], [620, 380], [880, 240], [1080, 500],
        [200, 380], [560, 120], [820, 500], [980, 120],
      ].map(([cx, cy], i) => (
        <g key={i}>
          <circle className="bek-network-node" cx={cx} cy={cy} r="3" />
          <circle cx={cx} cy={cy} r="8" fill="none" stroke="#C7CDD6" strokeOpacity="0.25" />
        </g>
      ))}
    </svg>
  );
}
